<template>
  <div class="material-container">
    <div class="material-main">
      <div class="material-main-banner-block">
        <img
          class="material-main-banner"
          :src="require('@/assets/images/expert/banner1.png')"
          alt=""
        />
        <img
          class="material-main-banner-logo"
          :src="require('@/assets/images/expert/logo.png')"
          alt=""
        />
      </div>
      <div class="material-main-item-block">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="material-main-item"
          @click="download(item)"
        >
          <img
            class="icon-img"
            :src="require(`@/assets/images/expert/${item.icon}.png`)"
            alt=""
          />
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyDialog from "@/components/unit/dialog/index.js";
export default {
  name: "material",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      list: [
        {
          icon: "invitation",
          key: "invitation_file",
          title: "下载邀请函",
          tipsText: "物料正在制作中，请稍后！",
        },
        {
          icon: "schedule",
          key: "file_schedule",
          title: "下载日程",
          tipsText: "物料正在制作中，请稍后！",
        },
        {
          icon: "poster",
          key: "file_regular_invitation",
          title: "下载海报",
          tipsText: "物料正在制作中，请稍后！",
        },
        {
          icon: "course",
          key: "meet_class_url",
          title: "下载课件幻灯",
          tipsText: "专家暂未上传课件",
        },
        {
          icon: "ppt",
          key: "file_slide_show",
          title: "下载串场幻灯",
          tipsText: "物料正在制作中，请稍后！",
        },
        {
          icon: "case",
          key: "xxx",
          title: "下载病例",
          tipsText: "专家暂未上传病例",
        },
        // {
        //   icon: "text",
        //   key: "host_file",
        //   title: "下载主持人稿",
        // },
        // {
        //   icon: "default",
        //   title: "......",
        // },
      ],
      meetInfo: {},
      materialShowFile: {},
    };
  },
  created() {
    this.loadData();
    this.loadMaterialShowFile();
  },
  methods: {
    loadData() {
      let url = this.$tools.getURL(this.$urls.meet.info, this.info.query);
      this.$axios
        .get(url)
        .then((res) => {
          this.meetInfo = res.data;
        })
        .catch((err) => {});
    },
    loadMaterialShowFile() {
      let url = this.$tools.getURL(
        this.$urls.meet.material_show_file,
        this.info.query
      );
      this.$axios
        .get(url)
        .then((res) => {
          this.materialShowFile = res.data;
        })
        .catch((err) => {});
    },
    download(item) {
      switch (item.icon) {
        case "case":
          if (
            this.materialShowFile.meet_share_class.shares.filter(
              (x) => x.meet_share_url != ""
            ).length == 0
          ) {
            this.$tips.error({ text: "专家暂未上传病例" });
            return;
          }
          MyDialog({
            link: "/page/meet/components/case.vue",
            data: this.materialShowFile.meet_share_class,
          })
            .then((res) => {
              this.$emit("updateMeetInfo");
            })
            .catch(() => {
              console.log(0);
            });
          break;
        case "invitation":
          if (
            this.materialShowFile.file_regular_pic_invitation == "" &&
            this.materialShowFile.file_simple_invitation == ""
          ) {
            this.$tips.error({ text: "物料正在制作中，请稍后！" });
            return;
          }
          MyDialog({
            link: "/page/meet/components/invitation.vue",
            data: this.materialShowFile,
          })
            .then((res) => {
              this.$emit("updateMeetInfo");
            })
            .catch(() => {
              console.log(0);
            });
          break;
        default:
          if (!this.materialShowFile[item.key]) {
            this.$tips.error({ text: item.tipsText });
            return;
          }
          this.$tools.download(this.materialShowFile[item.key]);
      }
      // if (item.icon == "case") {
      //   if(this.materialShowFile.meet_share_class.shares.filter(x=>x.meet_share_url!='').length == 0){
      //     this.$tips.error({ text: "专家暂未上传病例" })
      //     return;
      //   }
      //   MyDialog({ link: "/page/meet/components/case.vue", data: this.materialShowFile.meet_share_class }).then(res => {
      //     console.log(res)
      //     this.$emit("updateMeetInfo")
      //   }).catch(() => {
      //     console.log(0)
      //   })
      //   return;
      // } else {
      //   if (!this.materialShowFile[item.tipsText]) {
      //     this.$tips.error({ text: item.tipsText })
      //     return;
      //   }
      //   this.$tools.download(this.materialShowFile[item.key])
      // }
    },
  },
};
</script>
<style>
.material-container {
  width: 335px;

  position: relative;
  display: flex;
  justify-content: center;
}

.material-container-bg {
  background: #434343;
  opacity: 0.8;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}

.material-main {
  position: relative;
  background: #fafafa;
}

.material-main-banner-block {
  position: relative;
}

.material-main-banner-logo {
  position: absolute;
  top: 30px;
  z-index: 20;
  left: 50%;
  transform: translateX(-50%);
  width: 136px;
  height: 47px;
}

.material-main .material-main-banner {
  width: 100%;
}

.material-main-item-block {
  background: #fafafa;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 13px;
  padding: 20px 17px;

  color: #231815;
}

.material-main-item {
  width: 96px;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
  margin-bottom: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.material-main-item .icon-img {
  height: 25px;
  margin-bottom: 13px;
}
</style>